// EA商城、多空情绪等接口
import { get, post } from '~/assets/js/api/methods'

import apiList from '~/env.config'
const { fxServer, fxClient } = apiList

export default axios => ({
  // EA商城
  eaListServer: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/eashop/index/init-v1`, params), // 列表——服务端请求
  eaListClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/eashop/index/init-v1`, params), // 列表——客户端请求
  eaPraise: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/eashop/index/dot-v1`, params), // 点赞列表某一项
  eaDetail: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/eashop/detail/init-v1`, params), // EA详情页
  sendMail: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/eashop/detail/email-v1`, params), // 发送邮件

  // 多空情绪
  emotionList: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/position/slist/holdposition/init-v1`, params), // 多空情绪列表
  emotionListClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/position/slist/holdposition/init-v1`, params), // 多空情绪列表
  emotionDetailServer: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/position/holdposition/detail-v1`, params), // 多空情绪详情——服务端请求
  emotionDetailClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/position/holdposition/detail-v1`, params), // 多空情绪详情——客户端请求

  // 持仓分布
  holdDistributionServer: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/position/slist/init-v1`, params), // 持仓分布——服务端请求
  holdDistributionClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/position/slist/switch-v1`, params), // 持仓分布——客户端请求

  // 经纪商排行榜
  brokerRank: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/init-v1`, params), // 经纪商排行榜
  brokerHistoryServer: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/broker/history/init-v1`, params), // 某一类经纪商排行榜——服务端请求
  brokerHistoryClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/broker/history/init-v1`, params), // 某一类经纪商排行榜——客户端请求
  oneBrokerServer: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/dealer/detail/history/daydata-v1`, params), // 某一个经纪商详情——服务端请求
  oneBrokerClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/dealer/detail/history/daydata-v1`, params) // 某一个经纪商详情——客户端请求
})
